import { createContext, useContext, useEffect } from "react";

/**
 * Le Desk uses a **permanent dark theme** (Vertec brand decision).
 * The context is kept as a thin wrapper for backward compatibility with
 * components that read `theme` from it, but it will always return "dark"
 * and expose no toggle.
 */
const ThemeContext = createContext({ theme: "dark" });

export function ThemeProvider({ children }) {
  useEffect(() => {
    const html = document.documentElement;
    html.classList.remove("light");
    html.classList.add("dark");
    // Purge any stale user preference from previous versions.
    localStorage.removeItem("ledesk_theme");
  }, []);

  return (
    <ThemeContext.Provider value={{ theme: "dark" }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
